import { useContext, useEffect } from 'react'

import { helpers, useFetch } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'
import returnsServices from '@/returns/services/services'

import { checkLineItemsOutOfPolicy, isOrderOutOfPolicy } from './helpers'

const useTransactionRMA = ({ returnPortalId, orderName, customerEmail }) => {
  const { rmaInfo, setRmaInfo } = useContext(RMAContext)
  const { info } = useContext(AppContext)
  const {
    data: order,
    fetchData: fetchOrder,
    loading: fetchingOrder,
  } = useFetch(() => returnsServices.getOrderRma({ returnPortalId, orderName, customerEmail }), {
    doInitialRequest: returnPortalId && orderName && customerEmail,
  })

  useEffect(() => {
    if (order && info?.selectedStore) {
      const lineItemsWithPolicyChecked = checkLineItemsOutOfPolicy(order?.line_items)

      setRmaInfo(rmaInfo => ({
        ...rmaInfo,
        merchantInfo: {
          ...rmaInfo?.merchantInfo,
          ...info?.selectedStore,
          storeId: info?.selectedStore?.id,
          returnPortalId: info?.selectedReturnPortal?.id,
          preferences: {
            ...info?.selectedStore?.preferences,
            promote_exchanges: false,
          },
        },
        orderAmount: {
          ...rmaInfo?.orderAmount,
          currency: order?.currency,
        },
        orderInfo: {
          ...rmaInfo.orderInfo,
          ...order,
          shipping_address: helpers.formatUserAddress(order.shipping_address, order.customer_profile?.phone),
          line_items: helpers.joinLineItemsAndLineItemGroups(
            helpers.flattenLineItems(lineItemsWithPolicyChecked),
            order?.line_item_groups
          ),
          original_shipping_address: helpers.formatUserAddress(order.shipping_address, order.customer_profile?.phone),
          outOfPolicy: isOrderOutOfPolicy(order?.is_returnable_reason, lineItemsWithPolicyChecked),
        },
        variants: helpers.getLineItemsVariants(order?.line_items, order?.line_item_groups),
        allowed_region: order?.allowed_region,
      }))
    }
  }, [info.selectedStore, order, setRmaInfo, info.selectedReturnPortal])

  return { order, fetchOrder, fetchingOrder, rmaInfo, setRmaInfo }
}
export default useTransactionRMA
